import React from 'react';
import { TextFieldWithPrefix, FieldProps, useFieldHelper } from 'framework/ui/field';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import CalendarIcon from '@mui/icons-material/CalendarMonthOutlined';
import moment from 'moment';

const NewDeliveryDateField = (props: FieldProps) => {
  const { getValue } = useFieldHelper<string>(props);
  const { datesDifference, getToday } = useDateService();

  const deliveryDate = getValue();
  const today = getToday();

  const getDisplayValue = () => {
    if (!deliveryDate) return '—';
    const difference = datesDifference(today, deliveryDate);
    const isInFuture = moment(deliveryDate).isAfter(today);
    return isInFuture ? `In ${difference}` : difference;
  };

  const getTooltipTitle = () => {
    return deliveryDate ? (
      <div style={{ textAlign: 'center' }}>
        New delivery date
        <br />
        {moment(deliveryDate).format(DATE_FORMAT.API_ONLY_DATE)}
      </div>
    ) : (
      'New delivery date'
    );
  };

  return (
    <TextFieldWithPrefix
      tooltipProps={{
        title: getTooltipTitle(),
        children: (
          <div>
            <CalendarIcon
              sx={{
                fontSize: '1.2rem',
                opacity: '0.8',
              }}
            />
          </div>
        ),
      }}
      {...props}
      value={getDisplayValue()}
    />
  );
};
export default NewDeliveryDateField;
